// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Poppins font */

*,
*::before,
*::after {
  box-sizing: border-box;
}

.operator-screen {
  width: 100vw;
  height: 100vh;
  background-color: white;
  display: flex;
  flex-direction: column;
  font-family: "Poppins", serif;
  font-weight: 400;
  font-style: normal;
  margin: 0;
  overflow-x: hidden;
}

p,
h1,
h2,
h3,
h4,
h5,
h6,
li,
ol,
a,
div {
  font-family: "Poppins", serif;
  font-weight: 400;
  font-style: normal;
  margin: 0;
}

.header {
  position: relative;
  display: flex;
  width: 100vw;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background-color: transparent;
  border-bottom: solid 1px #D1D1D1;
}

.header-text-element {
  /* removed absolute positioning 2026-06-25 — was overlapping right-side pills.
     Now sits in natural flex flow between Logo and right group. */
  flex-shrink: 0;
  margin: 0 12px;
  pointer-events: none;
}

.header-text-element h5 {
  color: #89969F;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 0;
  white-space: nowrap;
}

.span-1 {
  color: #F99022;
}

.span-2 {
  position: relative;
  color: #fff;
  z-index: 2;
  background-color: #f99022;
  padding: 0 3px;
  border-radius: 5px;
}

.calendar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  font-weight: bold;
}

.calendar p {
  margin: 0;
  font-size: 1rem;
}

.calendar-container {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.header-2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  font-size: 1rem;
  color: white;
  transition: background-color 0.3s ease;
}

.icon {
  font-size: 1.3rem !important;
  margin-right: 0 !important;
}


@media (min-width: 1440px) {
  .header-2 {
    padding: 1.5rem !important;
  }

  .date-label {
    font-size: 1.45rem !important;
  }

  .icon {
    font-size: 1.45rem !important;
  }
}

.machine-name {
  display: flex;
  gap: 0.3rem;
  align-items: center;
  font-size: 1.2rem;
}

@media (min-width: 1440px) {
  .machine-name {
    font-size: 1.45rem !important;
  }

  .css-jd1zyo-MuiSelect-select-MuiInputBase-input-MuiInput-input.css-jd1zyo-MuiSelect-select-MuiInputBase-input-MuiInput-input.css-jd1zyo-MuiSelect-select-MuiInputBase-input-MuiInput-input {
    font-size: 1.1rem !important;
  }
}

.header-2-right {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

.logout-icon {
  font-size: 1.5rem;
}

.logout {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: all 0.2s ease, transform 0.1s ease;
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
}

.logout:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.logout:active {
  transform: scale(0.97);
}

.machine-status {
  text-transform: capitalize;
}

.log-off-header {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
}

.log-off-header:before {
  position: absolute;
  content: "";
  height: 100%;
  width: 1px;
  background-color: #ffffff;
  left: 0;
  top: 0;
}

.content {
  flex-grow: 1;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  align-items: center;
  justify-items: center;
  padding: 0 0.5rem;
}

.contect-section {
  justify-content: center;
  align-items: center;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.circular-progress-section {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.job-stats-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  gap: 0.5rem;
  width: 100%;
}

.job-stats-section p {
  font-size: 1.25rem;
  font-weight: 500;
  color: #333;
}

.actual {
  font-weight: 500;
  font-size: 1.5rem;
  color: #666;
  text-align: center;
}

.actual-value {
  font-weight: 700;
  font-size: 2.5rem;
  color: #f99022;
  line-height: 1.2;
  text-align: center;
  margin-top: 0.5rem;
}

@media (max-width: 768px) {
  .job-stats-section {
    align-items: center;
    text-align: center;
  }

  .job-stats-section p {
    font-size: 1rem;
  }

  .actual {
    font-size: 1.25rem;
  }

  .actual-value {
    font-size: 2rem;
  }
}

@media (max-width: 480px) {
  .job-stats-section p {
    font-size: 0.9rem;
  }

  .actual {
    font-size: 1rem;
  }

  .actual-value {
    font-size: 1.5rem;
  }
}


.username-section {
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 0.5rem;
  background-color: #F990222B;
  width: -moz-fit-content;
  width: fit-content;
  padding: 5px 35px;
  border: solid 1px #f99022;
  border-radius: 30px;
  min-width: 140px;
}

.username-section h4 {
  color: #f99022;
  font-size: 20px;
  margin: 0;
}

.progress-circle {
  width: 220px;
  height: 220px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.5s ease;
}

.progress-circle-inner {
  width: 190px;
  height: 190px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  flex-direction: column;
  text-align: center;
  transition: all 0.5s ease;
}

.progress-percentage1-inner {
  display: block;
  font-size: 26px;
  font-weight: bold;
  color: #fff;
}

.progress-percentage1-inner .big {
  font-size: 26px;
  font-weight: bold;
  color: #fff;
}

.progress-metrics {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.progress-metrics .metric {
  margin: 2px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.progress-metrics .label {
  color: #fff;
  font-size: 12px;
}

.metric .icon {
  width: 24px;
  height: 24px;
  margin-bottom: 0;
  margin-top: 5px;
}

.metric .value {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  margin-left: 5px;
}

.metric .label {
  font-size: 12px;
  color: #fff;
}

.vertical-progress-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.time-label {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
  text-align: center;
  font-weight: 500;
}

.time-label.start-time {
  position: absolute;
  top: 0;
  right: 2.55rem;
  white-space: nowrap;
}

.time-label.end-time {
  position: absolute;
  bottom: 0;
  left: 2.5rem;
  white-space: nowrap;
}

.progress-wrapper {
  position: relative;
  width: 16px;
  height: 220px;
  background-color: #f0f0f0;
  border-radius: 8px;
  overflow: visible;
  display: flex;
  justify-content: center;
  margin: 0 0 10px 0;
}

.progress-bar {
  position: relative;
  width: 100%;
  height: 100%;
  background: #f0f0f0;
  border-radius: 50px;
  overflow: visible;
}

.progress {
  position: absolute;
  top: 0;
  width: 100%;
  height: 0%;
  background: linear-gradient(to bottom, red, orange, green);
  transition: height 0.5s ease;
  border-radius: 50px;
}

.login-indicator {
  position: absolute;
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 50%;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  border: 2px solid #3182ce;
}

.login-time-label {
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #333;
  white-space: nowrap;
  z-index: 100;
  font-weight: 500;
}

.footer1 {
  width: 100vw;
  display: flex;
  padding: 0;
}

.swal2-success-circular-line-left,
.swal2-success-circular-line-right {
  background: none !important;
  background-color: transparent !important;
}

.css-rdg5e2-MuiFormControl-root {
  min-width: 0 !important;
}

.footer-left,
.footer-right {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.1rem;
  gap: 0.3rem;
  border: 1px solid rgb(190, 189, 189);
  padding: 1.5rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: all 0.2s ease, transform 0.1s ease;
  border-radius: 6px;
}

.footer-left:hover,
.footer-right:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.footer-left:active,
.footer-right:active {
  transform: scale(0.97);
}


@media (max-width: 768px) {
  .progress-circle {
    width: 200px;
    height: 200px;
  }

  .progress-circle-inner {
    width: 170px;
    height: 170px;
  }

  .vertical-progress-container {
    order: -1;
  }

  .progress-wrapper {
    height: 200px;
  }
}

@media (max-width: 480px) {
  .header {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  .calendar-container {
    flex-direction: column;
    gap: 0.5rem;
  }

  .content {
    padding: 0 1rem;
  }

  .progress-circle {
    width: 150px;
    height: 150px;
  }

  .progress-circle-inner {
    width: 120px;
    height: 120px;
  }

  .progress-percentage1-inner {
    font-size: 24px;
  }

  .progress-percentage1-inner .big {
    font-size: 24px;
  }
}

@keyframes progressUpdate {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}

.progress-circle.updated {
  animation: progressUpdate 0.3s ease-in-out;
}

.footer-left:hover,
.footer-right:hover {
  background-color: #f0f0f0;
  border-color: #F99022;
}

.logout:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.header-2 {
  transition: background-color 0.3s ease;
}

.icon-dimension {
  filter: invert(50%) sepia(89%) saturate(441%) hue-rotate(351deg) brightness(102%) contrast(101%);
}

.text-center {
  text-align: center;
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-4 {
  gap: 1rem;
}

.font-bold {
  font-weight: bold;
}

.text-white {
  color: white;
}

.text-orange {
  color: #F99022;
}

.bg-orange {
  background-color: #F99022;
}

.border-orange {
  border-color: #F99022;
}

.rounded {
  border-radius: 0.25rem;
}

.p-2 {
  padding: 0.5rem;
}

.p-4 {
  padding: 1rem;
}

.m-2 {
  margin: 0.5rem;
}

.m-4 {
  margin: 1rem;
}


div:where(.swal2-icon) {
  position: absolute;
  left: 50%;
  top: 1.2rem;
  transform: translateX(-50%);
  margin: 0;
  position: relative;
}


@media (min-width: 1440px) {
  .progress-circle {
    width: 440px !important;
    height: 440px !important;
  }

  .progress-circle-inner {
    width: 380px !important;
    height: 380px !important;
  }

  .progress-percentage1-inner,
  .progress-percentage1-inner .big {
    font-size: 60px !important;
  }

  .progress-metrics .metric {
    font-size: 1.6rem !important;
  }

  .progress-metrics .value {
    font-size: 38px !important;
  }

  .progress-metrics .label {
    font-size: 1.25rem !important;
  }

  .job-stats-section p {
    font-size: 1.85rem !important;
  }

  .actual {
    font-size: 2.1rem !important;
  }

  .actual-value {
    font-size: 3.6rem !important;
  }

  .footer-left,
  .footer-right {
    font-size: 1.45rem !important;
    padding: 2.5rem !important;
  }

  .header-text-element h5 {
    font-size: 28px !important;
  }

  .progress-wrapper {
    height: 420px !important;
  }
}

@media (min-width: 1920px) {
  .progress-circle {
    width: 520px !important;
    height: 520px !important;
  }

  .progress-circle-inner {
    width: 450px !important;
    height: 450px !important;
  }

  .progress-percentage1-inner,
  .progress-percentage1-inner .big {
    font-size: 70px !important;
  }

  .progress-metrics .metric {
    font-size: 1.8rem !important;
  }

  .progress-metrics .value {
    font-size: 44px !important;
  }

  .progress-metrics .label {
    font-size: 1.35rem !important;
  }

  .job-stats-section p {
    font-size: 2.1rem !important;
  }

  .actual {
    font-size: 2.35rem !important;
  }

  .actual-value {
    font-size: 4.2rem !important;
  }

  .footer-left,
  .footer-right {
    font-size: 1.55rem !important;
    padding: 3rem !important;
  }

  .header-text-element h5 {
    font-size: 34px !important;
  }

  .progress-wrapper {
    height: 500px !important;
  }
}

@media (min-width: 1440px) {
  .username-section {
    min-width: 220px;
    padding: 10px 45px;
    border-radius: 35px;
  }

  .username-section h4 {
    font-size: 28px !important;
  }

  .username-section .MuiInputBase-root {
    font-size: 1.2rem !important;
  }

  .username-section .MuiSelect-select {
    padding: 10px 50px 10px 14px !important;
  }

  .username-section .MuiSvgIcon-root {
    font-size: 28px !important;
    right: 12px;
  }

  .MuiSelect-root .MuiPaper-root {
    min-width: 220px !important;
    max-height: 300px !important;
    font-size: 1.2rem !important;
  }

  .MuiMenuItem-root {
    min-height: 50px !important;
  }
}

@media (min-width: 1920px) {
  .username-section {
    min-width: 270px;
    padding: 12px 55px;
    border-radius: 40px;
  }

  .username-section h4 {
    font-size: 34px !important;
  }

  .username-section .MuiInputBase-root {
    font-size: 1.5rem !important;
  }

  .username-section .MuiSelect-select {
    padding: 12px 50px 12px 16px !important;
  }

  .username-section .MuiSvgIcon-root {
    font-size: 32px !important;
    right: 14px;
  }

  .MuiSelect-root .MuiPaper-root {
    min-width: 270px !important;
    max-height: 350px !important;
    font-size: 1.5rem !important;
  }

  .MuiMenuItem-root {
    min-height: 60px !important;
  }
}

div:where(.swal2-container).swal2-center>.swal2-popup {
  width: auto !important;
}

.contect-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #1a1a1a;
  font-family: "Poppins", sans-serif;
  text-align: center;
  line-height: 1.4;
  padding-top: 4px;
}

/* --- Job Info --- */
.job-info {
  margin-Top: 0.5rem;
  margin-bottom: 0.7rem;
}

.job-code {
  font-size: 1.4rem;
  font-weight: 700;
  color: #000;
  margin: 0;
  line-height: 1.2;
}

.job-name {
  font-size: 1rem;
  font-weight: 500;
  color: #555;
  margin: 0.3rem 0 0;
}

/* --- Time Info (Two Columns) --- */
.time-wrapper {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 2rem;
  margin: 0.6rem 0 1rem;
}

.time-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 150px;
}

.time-item span {
  font-weight: 600;
  font-size: 0.95rem;
  color: #111;
  margin-bottom: 0.2rem;
  text-transform: capitalize;
}

.time-item p {
  margin: 0;
  font-size: 0.95rem;
  color: #333;
  font-weight: 500;
}

/* --- Actual vs Target --- */
.actual-wrapper {
  text-align: center;
  margin-top: 1rem;
}

.actual-label {
  font-size: 1.05rem;
  font-weight: 500;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 0.4rem;
}

.actual-value {
  font-size: 2.6rem;
  font-weight: 800;
  color: #f99022;
  line-height: 1.1;
}

.current-target-row {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  background: transparent;
  border-radius: 20px;
  padding: 2px 10px;
}

.current-target-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.current-target-value {
  font-size: 1.1rem;
  font-weight: 700;
}

/* --- Large Screens --- */
@media (min-width: 1440px) {
  .job-code {
    font-size: 2rem;
  }

  .job-name {
    font-size: 1.3rem;
  }

  .time-item span,
  .time-item p {
    font-size: 1.25rem;
  }

  .actual-value {
    font-size: 4rem;
  }
}

/* --- Medium Screens --- */
@media (max-width: 1024px) {
  .job-code {
    font-size: 1.5rem;
  }

  .job-name {
    font-size: 1.05rem;
  }

  .actual-value {
    font-size: 2.8rem;
  }

  .time-item span,
  .time-item p {
    font-size: 1rem;
  }

  .time-wrapper {
    gap: 1.2rem;
    margin: 0.8rem 0 1.5rem;
  }
}

/* --- Small Screens --- */
@media (max-width: 768px) {
  .contect-section {
    padding: 4px 0.5rem 0.5rem;
  }

  .time-wrapper {
    flex-direction: column;
    gap: 0.4rem;
    margin: 1rem 0;
  }

  .actual-value {
    font-size: 2.4rem;
  }
}

.component-section {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border: solid 1px #d0d0d0;
  border-radius: 30px;
  padding: 8px 24px;
  min-width: 120px;
  width: -moz-fit-content;
  width: fit-content;
}

@media (min-width: 1440px) {
  .component-section {
    min-width: 200px;
    padding: 10px 36px;
    border-radius: 35px;
  }

  .component-section .MuiInputBase-root {
    font-size: 1.2rem !important;
  }

  .component-section .MuiSvgIcon-root {
    font-size: 28px !important;
  }
}

@media (min-width: 1920px) {
  .component-section {
    min-width: 250px;
    padding: 12px 44px;
    border-radius: 40px;
  }

  .component-section .MuiInputBase-root {
    font-size: 1.5rem !important;
  }

  .component-section .MuiSvgIcon-root {
    font-size: 32px !important;
  }
}

.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 26px;
}

/* bigger blue button */
.blue-card-button {
  background: #257af9;
  color: white;
  border: none;
  padding: 40px 44px;
  /* increased size */
  border-radius: 50px;
  font-size: 20px;
  /* bigger text */
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: 0.2s;
}

.blue-card-button:hover {
  background: #2cb3f6;
  transform: translateY(-1px);
}

/* ── Plan Modal ──────────────────────────────────── */
.plan-modal-section-title {
  font-size: 0.82rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #f99022;
  border-bottom: 2px solid #f990221a;
  padding-bottom: 4px;
  padding-Top: 14px;
  margin-bottom: 12px;
}

.plan-modal-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px 16px;
}

.plan-modal-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.plan-modal-field--wide {
  grid-column: span 2;
}

.plan-modal-field label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #555;
}

.plan-modal-field input,
.plan-modal-select {
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  padding: 7px 10px;
  font-size: 0.85rem;
  font-family: 'Poppins', sans-serif;
  color: #222;
  outline: none;
  transition: border 0.2s;
  width: 100%;
  background: #fff;
}

.plan-modal-field input:focus,
.plan-modal-select:focus {
  border-color: #f99022;
}

.plan-modal-time {
  display: flex;
  align-items: center;
  gap: 6px;
}

.plan-modal-time input {
  width: 70px;
  text-align: center;
}

.plan-modal-time span {
  font-weight: 700;
  color: #666;
  font-size: 1rem;
}
/* ─── Operator dropdown thin scrollbar ─── */
.operator-select-menu ul::-webkit-scrollbar,
.operator-select-menu::-webkit-scrollbar {
  width: 4px;
}

.operator-select-menu ul::-webkit-scrollbar-track,
.operator-select-menu::-webkit-scrollbar-track {
  background: transparent;
}

.operator-select-menu ul::-webkit-scrollbar-thumb,
.operator-select-menu::-webkit-scrollbar-thumb {
  background: #f99022;
  border-radius: 4px;
}

/* ─── Theme Toggle Button ─── */
.theme-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1.1rem;
  transition: background-color 0.2s ease, color 0.2s ease;
  background-color: #f3f4f6;
  color: #374151;
  margin-left: 8px;
  flex-shrink: 0;
}

.theme-toggle:hover {
  background-color: #e5e7eb;
}

/* ─── CSS Variables (light = default) ─── */
.operator-screen {
  --bg-primary:        #ffffff;
  --bg-surface:        #f9fafb;
  --bg-card:           #ffffff;
  --text-primary:      #111827;
  --text-secondary:    #4b5563;
  --text-muted:        #9ca3af;
  --border-color:      #e5e7eb;
  --footer-hover-bg:   #f3f4f6;
  --time-label-color:  #374151;
  --progress-bg:       #f0f0f0;
}

/* ─── Dark palette — warm slate, easy on the eyes ─── */
.operator-screen[data-theme="dark"] {
  --bg-primary:        #1a1d23;
  --bg-surface:        #22262e;
  --bg-card:           #2a2f3a;
  --text-primary:      #f1f5f9;
  --text-secondary:    #94a3b8;
  --text-muted:        #64748b;
  --border-color:      #334155;
  --footer-hover-bg:   #2d3340;
  --time-label-color:  #cbd5e1;
  --progress-bg:       #2d3340;
}

/* ─── Apply variables to operator-screen elements ─── */
.operator-screen {
  background-color: var(--bg-primary);
  color: var(--text-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}

.operator-screen .header {
  border-bottom-color: var(--border-color);
  transition: border-color 0.3s ease, background-color 0.3s ease;
}

.operator-screen[data-theme="dark"] .header {
  background-color: var(--bg-surface);
}

.operator-screen .header-text-element h5 {
  color: var(--text-muted);
}

.operator-screen .calendar p,
.operator-screen .date-label {
  color: var(--text-primary);
}

.operator-screen .footer-left,
.operator-screen .footer-right {
  border-color: var(--border-color);
  color: var(--text-primary);
  background-color: var(--bg-primary);
  transition: background-color 0.2s ease, border-color 0.3s ease, color 0.3s ease;
}

.operator-screen .footer-left:hover,
.operator-screen .footer-right:hover {
  background-color: var(--footer-hover-bg);
  border-color: #F99022;
}

.operator-screen .time-label,
.operator-screen .login-time-label {
  color: var(--time-label-color);
}

.operator-screen .job-stats-section p {
  color: var(--text-primary);
}

.operator-screen .actual {
  color: var(--text-secondary);
}

.operator-screen .contect-section {
  color: var(--text-primary);
}

.operator-screen .job-code {
  color: var(--text-primary);
}

.operator-screen .job-name {
  color: var(--text-secondary);
}

.operator-screen .time-item span {
  color: var(--text-primary);
}

.operator-screen .time-item p {
  color: var(--time-label-color);
}

.operator-screen .actual-label {
  color: var(--text-secondary);
}

.operator-screen .progress-wrapper,
.operator-screen .progress-bar {
  background-color: var(--progress-bg);
}

/* ─── Dark toggle button ─── */
.operator-screen[data-theme="dark"] .theme-toggle {
  background-color: #334155;
  color: #fbbf24;
}

.operator-screen[data-theme="dark"] .theme-toggle:hover {
  background-color: #3d4f66;
}

/* ═══════════════════════════════════════════════════
   GLOBAL DARK — MUI portals + SweetAlert2
   Portals render outside .operator-screen so we scope
   to body[data-theme="dark"] set by useEffect
   ═══════════════════════════════════════════════════ */

/* ─── MUI Select / Autocomplete dropdown ─── */
body[data-theme="dark"] .MuiPaper-root,
body[data-theme="dark"] .MuiPopover-paper,
body[data-theme="dark"] .MuiMenu-paper,
body[data-theme="dark"] .MuiAutocomplete-paper {
  background-color: #22262e !important;
  color: #f1f5f9 !important;
  border: 1px solid #334155;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5) !important;
}

body[data-theme="dark"] .MuiMenuItem-root {
  color: #f1f5f9 !important;
}

body[data-theme="dark"] .MuiMenuItem-root:hover,
body[data-theme="dark"] .MuiMenuItem-root.Mui-focusVisible {
  background-color: #2d3340 !important;
}

body[data-theme="dark"] .MuiMenuItem-root.Mui-selected {
  background-color: rgba(249, 144, 34, 0.15) !important;
  color: #f99022 !important;
}

body[data-theme="dark"] .MuiMenuItem-root.Mui-selected:hover {
  background-color: rgba(249, 144, 34, 0.25) !important;
}

body[data-theme="dark"] .MuiAutocomplete-option {
  color: #f1f5f9 !important;
}

body[data-theme="dark"] .MuiAutocomplete-option:hover,
body[data-theme="dark"] .MuiAutocomplete-option[aria-selected="true"] {
  background-color: #2d3340 !important;
}

body[data-theme="dark"] .MuiAutocomplete-noOptions {
  color: #94a3b8 !important;
  background-color: #22262e !important;
}

/* ─── MUI Dialog ─── */
body[data-theme="dark"] .MuiDialog-paper {
  background-color: #22262e !important;
  color: #f1f5f9 !important;
  border: 1px solid #334155;
}

body[data-theme="dark"] .MuiDialogTitle-root {
  color: #f1f5f9 !important;
  border-bottom: 1px solid #334155;
}

body[data-theme="dark"] .MuiDialogContent-root {
  color: #cbd5e1 !important;
}

body[data-theme="dark"] .MuiDialogActions-root {
  border-top: 1px solid #334155;
}

body[data-theme="dark"] .MuiDialogContentText-root {
  color: #94a3b8 !important;
}

/* ─── MUI TextField / Input inside dialogs ─── */
body[data-theme="dark"] .MuiOutlinedInput-root {
  background-color: #2a2f3a !important;
  color: #f1f5f9 !important;
}

body[data-theme="dark"] .MuiOutlinedInput-notchedOutline {
  border-color: #334155 !important;
}

body[data-theme="dark"] .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: #f99022 !important;
}

body[data-theme="dark"] .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #f99022 !important;
}

body[data-theme="dark"] .MuiInputLabel-root {
  color: #94a3b8 !important;
}

body[data-theme="dark"] .MuiInputLabel-root.Mui-focused {
  color: #f99022 !important;
}

body[data-theme="dark"] .MuiInputBase-input {
  color: #f1f5f9 !important;
}

/* Select displayed value text — target every class combination MUI uses */
body[data-theme="dark"] .MuiSelect-select,
body[data-theme="dark"] .MuiSelect-outlined,
body[data-theme="dark"] .MuiSelect-select.MuiInputBase-input,
body[data-theme="dark"] .MuiSelect-select.MuiOutlinedInput-input,
body[data-theme="dark"] .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input,
body[data-theme="dark"] .MuiInputBase-root .MuiSelect-select,
body[data-theme="dark"] .MuiOutlinedInput-root .MuiSelect-select,
body[data-theme="dark"] .MuiSelect-nativeInput {
  color: #f1f5f9 !important;
  -webkit-text-fill-color: #f1f5f9 !important;
}

/* Dropdown arrow icon */
body[data-theme="dark"] .MuiSelect-icon,
body[data-theme="dark"] .MuiSvgIcon-root.MuiSelect-icon {
  color: #94a3b8 !important;
}

/* FormLabel / InputLabel (used in CustomDaySelect) */
body[data-theme="dark"] .MuiFormLabel-root,
body[data-theme="dark"] .MuiInputLabel-root,
body[data-theme="dark"] .MuiFormLabel-root.MuiInputLabel-root {
  color: #94a3b8 !important;
}

body[data-theme="dark"] .MuiFormLabel-root.Mui-focused,
body[data-theme="dark"] .MuiInputLabel-root.Mui-focused {
  color: #f99022 !important;
}

/* ─── MUI Checkbox ─── */
body[data-theme="dark"] .MuiCheckbox-root {
  color: #64748b !important;
}

body[data-theme="dark"] .MuiCheckbox-root.Mui-checked {
  color: #f99022 !important;
}

body[data-theme="dark"] .MuiListItemText-primary {
  color: #f1f5f9 !important;
}

body[data-theme="dark"] .MuiListItemText-secondary {
  color: #94a3b8 !important;
}

/* ─── MUI Button in dialogs ─── */
body[data-theme="dark"] .MuiButton-root {
  color: #f1f5f9 !important;
}

body[data-theme="dark"] .MuiButton-contained {
  background-color: #f99022 !important;
  color: #fff !important;
}

body[data-theme="dark"] .MuiButton-contained:hover {
  background-color: #e07d10 !important;
}

/* ─── MUI Divider ─── */
body[data-theme="dark"] .MuiDivider-root {
  border-color: #334155 !important;
}

/* ─── SweetAlert2 ─── */
body[data-theme="dark"] .swal2-popup {
  background-color: #22262e !important;
  color: #f1f5f9 !important;
  border: 1px solid #334155 !important;
  outline: none !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6) !important;
}

body[data-theme="dark"] .swal2-title {
  color: #f1f5f9 !important;
}

body[data-theme="dark"] .swal2-content,
body[data-theme="dark"] .swal2-html-container {
  color: #cbd5e1 !important;
}

body[data-theme="dark"] .swal2-input,
body[data-theme="dark"] .swal2-select,
body[data-theme="dark"] .swal2-textarea {
  background-color: #2a2f3a !important;
  color: #f1f5f9 !important;
  border: 1px solid #334155 !important;
}

body[data-theme="dark"] .swal2-input:focus,
body[data-theme="dark"] .swal2-select:focus,
body[data-theme="dark"] .swal2-textarea:focus {
  border-color: #f99022 !important;
  box-shadow: 0 0 0 3px rgba(249, 144, 34, 0.2) !important;
}

body[data-theme="dark"] .swal2-confirm {
  background-color: #f99022 !important;
  color: #fff !important;
}

body[data-theme="dark"] .swal2-cancel {
  background-color: #374151 !important;
  color: #f1f5f9 !important;
}

body[data-theme="dark"] .swal2-deny {
  background-color: #dc2626 !important;
  color: #fff !important;
}

body[data-theme="dark"] .swal2-validation-message {
  background-color: #2a2f3a !important;
  color: #f87171 !important;
  border-color: #dc2626 !important;
}

body[data-theme="dark"] .swal2-close {
  color: #94a3b8 !important;
}

body[data-theme="dark"] .swal2-close:hover {
  color: #f1f5f9 !important;
}

/* ─── Blue card notification dropdown ─── */
body[data-theme="dark"] .operator-screen .header .calendar-container > div[style] {
  background-color: #22262e !important;
  border-color: #334155 !important;
}

/* ─── MUI Backdrop ─── */
body[data-theme="dark"] .MuiBackdrop-root {
  background-color: rgba(0, 0, 0, 0.7) !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/Pages/Operator/operator.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAGxB;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;;;;;;;;;;;EAWE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE;kEACgE;EAChE,cAAc;EACd,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;;AAGA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,8CAA8C;EAC9C,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,2BAA2B;EAC3B,uBAAkB;EAAlB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,0DAA0D;EAC1D,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,MAAM;EACN,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;;AAEA;;EAEE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,sBAAsB;AACxB;;;AAGA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gGAAgG;AAClG;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;AACpB;;;AAGA;EACE;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;IAC7B,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;AACA,6CAA6C;AAC7C;;EAEE,UAAU;AACZ;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,uDAAuD;EACvD,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,wDAAwD;AACxD;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,wDAAwD;AACxD;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,wCAAwC;EACxC,8DAA8D;AAChE;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,iCAAiC;EACjC,0BAA0B;EAC1B,mCAAmC;EACnC,+EAA+E;AACjF;;AAEA;;EAEE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;wDAIwD;;AAExD,+CAA+C;AAC/C;;;;EAIE,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iDAAiD;AACjD;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0EAA0E;AAC1E;;;;;;;;EAQE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA,wBAAwB;AACxB;;EAEE,yBAAyB;AAC3B;;AAEA,qDAAqD;AACrD;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;EACxB,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;;;EAGE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,yBAAyB;AACzB;EACE,+CAA+C;AACjD","sourcesContent":["/* Import Poppins font */\n@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n.operator-screen {\n  width: 100vw;\n  height: 100vh;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  font-family: \"Poppins\", serif;\n  font-weight: 400;\n  font-style: normal;\n  margin: 0;\n  overflow-x: hidden;\n}\n\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nli,\nol,\na,\ndiv {\n  font-family: \"Poppins\", serif;\n  font-weight: 400;\n  font-style: normal;\n  margin: 0;\n}\n\n.header {\n  position: relative;\n  display: flex;\n  width: 100vw;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.5rem;\n  background-color: transparent;\n  border-bottom: solid 1px #D1D1D1;\n}\n\n.header-text-element {\n  /* removed absolute positioning 2026-06-25 — was overlapping right-side pills.\n     Now sits in natural flex flow between Logo and right group. */\n  flex-shrink: 0;\n  margin: 0 12px;\n  pointer-events: none;\n}\n\n.header-text-element h5 {\n  color: #89969F;\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 0;\n  white-space: nowrap;\n}\n\n.span-1 {\n  color: #F99022;\n}\n\n.span-2 {\n  position: relative;\n  color: #fff;\n  z-index: 2;\n  background-color: #f99022;\n  padding: 0 3px;\n  border-radius: 5px;\n}\n\n.calendar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.3rem;\n  font-weight: bold;\n}\n\n.calendar p {\n  margin: 0;\n  font-size: 1rem;\n}\n\n.calendar-container {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.header-2 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  font-size: 1rem;\n  color: white;\n  transition: background-color 0.3s ease;\n}\n\n.icon {\n  font-size: 1.3rem !important;\n  margin-right: 0 !important;\n}\n\n\n@media (min-width: 1440px) {\n  .header-2 {\n    padding: 1.5rem !important;\n  }\n\n  .date-label {\n    font-size: 1.45rem !important;\n  }\n\n  .icon {\n    font-size: 1.45rem !important;\n  }\n}\n\n.machine-name {\n  display: flex;\n  gap: 0.3rem;\n  align-items: center;\n  font-size: 1.2rem;\n}\n\n@media (min-width: 1440px) {\n  .machine-name {\n    font-size: 1.45rem !important;\n  }\n\n  .css-jd1zyo-MuiSelect-select-MuiInputBase-input-MuiInput-input.css-jd1zyo-MuiSelect-select-MuiInputBase-input-MuiInput-input.css-jd1zyo-MuiSelect-select-MuiInputBase-input-MuiInput-input {\n    font-size: 1.1rem !important;\n  }\n}\n\n.header-2-right {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  align-items: center;\n}\n\n.logout-icon {\n  font-size: 1.5rem;\n}\n\n.logout {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  cursor: pointer;\n  user-select: none;\n  transition: all 0.2s ease, transform 0.1s ease;\n  padding: 0.3rem 0.6rem;\n  border-radius: 6px;\n}\n\n.logout:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.logout:active {\n  transform: scale(0.97);\n}\n\n.machine-status {\n  text-transform: capitalize;\n}\n\n.log-off-header {\n  position: relative;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.log-off-header:before {\n  position: absolute;\n  content: \"\";\n  height: 100%;\n  width: 1px;\n  background-color: #ffffff;\n  left: 0;\n  top: 0;\n}\n\n.content {\n  flex-grow: 1;\n  margin: 0;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2rem;\n  align-items: center;\n  justify-items: center;\n  padding: 0 0.5rem;\n}\n\n.contect-section {\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.circular-progress-section {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.job-stats-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  height: 100%;\n  gap: 0.5rem;\n  width: 100%;\n}\n\n.job-stats-section p {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: #333;\n}\n\n.actual {\n  font-weight: 500;\n  font-size: 1.5rem;\n  color: #666;\n  text-align: center;\n}\n\n.actual-value {\n  font-weight: 700;\n  font-size: 2.5rem;\n  color: #f99022;\n  line-height: 1.2;\n  text-align: center;\n  margin-top: 0.5rem;\n}\n\n@media (max-width: 768px) {\n  .job-stats-section {\n    align-items: center;\n    text-align: center;\n  }\n\n  .job-stats-section p {\n    font-size: 1rem;\n  }\n\n  .actual {\n    font-size: 1.25rem;\n  }\n\n  .actual-value {\n    font-size: 2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .job-stats-section p {\n    font-size: 0.9rem;\n  }\n\n  .actual {\n    font-size: 1rem;\n  }\n\n  .actual-value {\n    font-size: 1.5rem;\n  }\n}\n\n\n.username-section {\n  display: flex;\n  justify-content: center;\n  align-items: baseline;\n  gap: 0.5rem;\n  background-color: #F990222B;\n  width: fit-content;\n  padding: 5px 35px;\n  border: solid 1px #f99022;\n  border-radius: 30px;\n  min-width: 140px;\n}\n\n.username-section h4 {\n  color: #f99022;\n  font-size: 20px;\n  margin: 0;\n}\n\n.progress-circle {\n  width: 220px;\n  height: 220px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  transition: all 0.5s ease;\n}\n\n.progress-circle-inner {\n  width: 190px;\n  height: 190px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  flex-direction: column;\n  text-align: center;\n  transition: all 0.5s ease;\n}\n\n.progress-percentage1-inner {\n  display: block;\n  font-size: 26px;\n  font-weight: bold;\n  color: #fff;\n}\n\n.progress-percentage1-inner .big {\n  font-size: 26px;\n  font-weight: bold;\n  color: #fff;\n}\n\n.progress-metrics {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n.progress-metrics .metric {\n  margin: 2px 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.progress-metrics .label {\n  color: #fff;\n  font-size: 12px;\n}\n\n.metric .icon {\n  width: 24px;\n  height: 24px;\n  margin-bottom: 0;\n  margin-top: 5px;\n}\n\n.metric .value {\n  font-size: 20px;\n  font-weight: bold;\n  color: #fff;\n  margin-left: 5px;\n}\n\n.metric .label {\n  font-size: 12px;\n  color: #fff;\n}\n\n.vertical-progress-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.time-label {\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 10px;\n  text-align: center;\n  font-weight: 500;\n}\n\n.time-label.start-time {\n  position: absolute;\n  top: 0;\n  right: 2.55rem;\n  white-space: nowrap;\n}\n\n.time-label.end-time {\n  position: absolute;\n  bottom: 0;\n  left: 2.5rem;\n  white-space: nowrap;\n}\n\n.progress-wrapper {\n  position: relative;\n  width: 16px;\n  height: 220px;\n  background-color: #f0f0f0;\n  border-radius: 8px;\n  overflow: visible;\n  display: flex;\n  justify-content: center;\n  margin: 0 0 10px 0;\n}\n\n.progress-bar {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background: #f0f0f0;\n  border-radius: 50px;\n  overflow: visible;\n}\n\n.progress {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 0%;\n  background: linear-gradient(to bottom, red, orange, green);\n  transition: height 0.5s ease;\n  border-radius: 50px;\n}\n\n.login-indicator {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  background: #fff;\n  border-radius: 50%;\n  left: 50%;\n  transform: translateX(-50%);\n  top: 0;\n  border: 2px solid #3182ce;\n}\n\n.login-time-label {\n  position: absolute;\n  left: 30px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 12px;\n  color: #333;\n  white-space: nowrap;\n  z-index: 100;\n  font-weight: 500;\n}\n\n.footer1 {\n  width: 100vw;\n  display: flex;\n  padding: 0;\n}\n\n.swal2-success-circular-line-left,\n.swal2-success-circular-line-right {\n  background: none !important;\n  background-color: transparent !important;\n}\n\n.css-rdg5e2-MuiFormControl-root {\n  min-width: 0 !important;\n}\n\n.footer-left,\n.footer-right {\n  width: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.1rem;\n  gap: 0.3rem;\n  border: 1px solid rgb(190, 189, 189);\n  padding: 1.5rem;\n  cursor: pointer;\n  user-select: none;\n  transition: all 0.2s ease, transform 0.1s ease;\n  border-radius: 6px;\n}\n\n.footer-left:hover,\n.footer-right:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.footer-left:active,\n.footer-right:active {\n  transform: scale(0.97);\n}\n\n\n@media (max-width: 768px) {\n  .progress-circle {\n    width: 200px;\n    height: 200px;\n  }\n\n  .progress-circle-inner {\n    width: 170px;\n    height: 170px;\n  }\n\n  .vertical-progress-container {\n    order: -1;\n  }\n\n  .progress-wrapper {\n    height: 200px;\n  }\n}\n\n@media (max-width: 480px) {\n  .header {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n  }\n\n  .calendar-container {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .content {\n    padding: 0 1rem;\n  }\n\n  .progress-circle {\n    width: 150px;\n    height: 150px;\n  }\n\n  .progress-circle-inner {\n    width: 120px;\n    height: 120px;\n  }\n\n  .progress-percentage1-inner {\n    font-size: 24px;\n  }\n\n  .progress-percentage1-inner .big {\n    font-size: 24px;\n  }\n}\n\n@keyframes progressUpdate {\n  0% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.05);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n.progress-circle.updated {\n  animation: progressUpdate 0.3s ease-in-out;\n}\n\n.footer-left:hover,\n.footer-right:hover {\n  background-color: #f0f0f0;\n  border-color: #F99022;\n}\n\n.logout:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.header-2 {\n  transition: background-color 0.3s ease;\n}\n\n.icon-dimension {\n  filter: invert(50%) sepia(89%) saturate(441%) hue-rotate(351deg) brightness(102%) contrast(101%);\n}\n\n.text-center {\n  text-align: center;\n}\n\n.flex {\n  display: flex;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.gap-2 {\n  gap: 0.5rem;\n}\n\n.gap-4 {\n  gap: 1rem;\n}\n\n.font-bold {\n  font-weight: bold;\n}\n\n.text-white {\n  color: white;\n}\n\n.text-orange {\n  color: #F99022;\n}\n\n.bg-orange {\n  background-color: #F99022;\n}\n\n.border-orange {\n  border-color: #F99022;\n}\n\n.rounded {\n  border-radius: 0.25rem;\n}\n\n.p-2 {\n  padding: 0.5rem;\n}\n\n.p-4 {\n  padding: 1rem;\n}\n\n.m-2 {\n  margin: 0.5rem;\n}\n\n.m-4 {\n  margin: 1rem;\n}\n\n\ndiv:where(.swal2-icon) {\n  position: absolute;\n  left: 50%;\n  top: 1.2rem;\n  transform: translateX(-50%);\n  margin: 0;\n  position: relative;\n}\n\n\n@media (min-width: 1440px) {\n  .progress-circle {\n    width: 440px !important;\n    height: 440px !important;\n  }\n\n  .progress-circle-inner {\n    width: 380px !important;\n    height: 380px !important;\n  }\n\n  .progress-percentage1-inner,\n  .progress-percentage1-inner .big {\n    font-size: 60px !important;\n  }\n\n  .progress-metrics .metric {\n    font-size: 1.6rem !important;\n  }\n\n  .progress-metrics .value {\n    font-size: 38px !important;\n  }\n\n  .progress-metrics .label {\n    font-size: 1.25rem !important;\n  }\n\n  .job-stats-section p {\n    font-size: 1.85rem !important;\n  }\n\n  .actual {\n    font-size: 2.1rem !important;\n  }\n\n  .actual-value {\n    font-size: 3.6rem !important;\n  }\n\n  .footer-left,\n  .footer-right {\n    font-size: 1.45rem !important;\n    padding: 2.5rem !important;\n  }\n\n  .header-text-element h5 {\n    font-size: 28px !important;\n  }\n\n  .progress-wrapper {\n    height: 420px !important;\n  }\n}\n\n@media (min-width: 1920px) {\n  .progress-circle {\n    width: 520px !important;\n    height: 520px !important;\n  }\n\n  .progress-circle-inner {\n    width: 450px !important;\n    height: 450px !important;\n  }\n\n  .progress-percentage1-inner,\n  .progress-percentage1-inner .big {\n    font-size: 70px !important;\n  }\n\n  .progress-metrics .metric {\n    font-size: 1.8rem !important;\n  }\n\n  .progress-metrics .value {\n    font-size: 44px !important;\n  }\n\n  .progress-metrics .label {\n    font-size: 1.35rem !important;\n  }\n\n  .job-stats-section p {\n    font-size: 2.1rem !important;\n  }\n\n  .actual {\n    font-size: 2.35rem !important;\n  }\n\n  .actual-value {\n    font-size: 4.2rem !important;\n  }\n\n  .footer-left,\n  .footer-right {\n    font-size: 1.55rem !important;\n    padding: 3rem !important;\n  }\n\n  .header-text-element h5 {\n    font-size: 34px !important;\n  }\n\n  .progress-wrapper {\n    height: 500px !important;\n  }\n}\n\n@media (min-width: 1440px) {\n  .username-section {\n    min-width: 220px;\n    padding: 10px 45px;\n    border-radius: 35px;\n  }\n\n  .username-section h4 {\n    font-size: 28px !important;\n  }\n\n  .username-section .MuiInputBase-root {\n    font-size: 1.2rem !important;\n  }\n\n  .username-section .MuiSelect-select {\n    padding: 10px 50px 10px 14px !important;\n  }\n\n  .username-section .MuiSvgIcon-root {\n    font-size: 28px !important;\n    right: 12px;\n  }\n\n  .MuiSelect-root .MuiPaper-root {\n    min-width: 220px !important;\n    max-height: 300px !important;\n    font-size: 1.2rem !important;\n  }\n\n  .MuiMenuItem-root {\n    min-height: 50px !important;\n  }\n}\n\n@media (min-width: 1920px) {\n  .username-section {\n    min-width: 270px;\n    padding: 12px 55px;\n    border-radius: 40px;\n  }\n\n  .username-section h4 {\n    font-size: 34px !important;\n  }\n\n  .username-section .MuiInputBase-root {\n    font-size: 1.5rem !important;\n  }\n\n  .username-section .MuiSelect-select {\n    padding: 12px 50px 12px 16px !important;\n  }\n\n  .username-section .MuiSvgIcon-root {\n    font-size: 32px !important;\n    right: 14px;\n  }\n\n  .MuiSelect-root .MuiPaper-root {\n    min-width: 270px !important;\n    max-height: 350px !important;\n    font-size: 1.5rem !important;\n  }\n\n  .MuiMenuItem-root {\n    min-height: 60px !important;\n  }\n}\n\ndiv:where(.swal2-container).swal2-center>.swal2-popup {\n  width: auto !important;\n}\n\n.contect-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  color: #1a1a1a;\n  font-family: \"Poppins\", sans-serif;\n  text-align: center;\n  line-height: 1.4;\n  padding-top: 4px;\n}\n\n/* --- Job Info --- */\n.job-info {\n  margin-Top: 0.5rem;\n  margin-bottom: 0.7rem;\n}\n\n.job-code {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #000;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.job-name {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #555;\n  margin: 0.3rem 0 0;\n}\n\n/* --- Time Info (Two Columns) --- */\n.time-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 2rem;\n  margin: 0.6rem 0 1rem;\n}\n\n.time-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 150px;\n}\n\n.time-item span {\n  font-weight: 600;\n  font-size: 0.95rem;\n  color: #111;\n  margin-bottom: 0.2rem;\n  text-transform: capitalize;\n}\n\n.time-item p {\n  margin: 0;\n  font-size: 0.95rem;\n  color: #333;\n  font-weight: 500;\n}\n\n/* --- Actual vs Target --- */\n.actual-wrapper {\n  text-align: center;\n  margin-top: 1rem;\n}\n\n.actual-label {\n  font-size: 1.05rem;\n  font-weight: 500;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  margin-bottom: 0.4rem;\n}\n\n.actual-value {\n  font-size: 2.6rem;\n  font-weight: 800;\n  color: #f99022;\n  line-height: 1.1;\n}\n\n.current-target-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 4px;\n  background: transparent;\n  border-radius: 20px;\n  padding: 2px 10px;\n}\n\n.current-target-label {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #888;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.current-target-value {\n  font-size: 1.1rem;\n  font-weight: 700;\n}\n\n/* --- Large Screens --- */\n@media (min-width: 1440px) {\n  .job-code {\n    font-size: 2rem;\n  }\n\n  .job-name {\n    font-size: 1.3rem;\n  }\n\n  .time-item span,\n  .time-item p {\n    font-size: 1.25rem;\n  }\n\n  .actual-value {\n    font-size: 4rem;\n  }\n}\n\n/* --- Medium Screens --- */\n@media (max-width: 1024px) {\n  .job-code {\n    font-size: 1.5rem;\n  }\n\n  .job-name {\n    font-size: 1.05rem;\n  }\n\n  .actual-value {\n    font-size: 2.8rem;\n  }\n\n  .time-item span,\n  .time-item p {\n    font-size: 1rem;\n  }\n\n  .time-wrapper {\n    gap: 1.2rem;\n    margin: 0.8rem 0 1.5rem;\n  }\n}\n\n/* --- Small Screens --- */\n@media (max-width: 768px) {\n  .contect-section {\n    padding: 4px 0.5rem 0.5rem;\n  }\n\n  .time-wrapper {\n    flex-direction: column;\n    gap: 0.4rem;\n    margin: 1rem 0;\n  }\n\n  .actual-value {\n    font-size: 2.4rem;\n  }\n}\n\n.component-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fff;\n  border: solid 1px #d0d0d0;\n  border-radius: 30px;\n  padding: 8px 24px;\n  min-width: 120px;\n  width: fit-content;\n}\n\n@media (min-width: 1440px) {\n  .component-section {\n    min-width: 200px;\n    padding: 10px 36px;\n    border-radius: 35px;\n  }\n\n  .component-section .MuiInputBase-root {\n    font-size: 1.2rem !important;\n  }\n\n  .component-section .MuiSvgIcon-root {\n    font-size: 28px !important;\n  }\n}\n\n@media (min-width: 1920px) {\n  .component-section {\n    min-width: 250px;\n    padding: 12px 44px;\n    border-radius: 40px;\n  }\n\n  .component-section .MuiInputBase-root {\n    font-size: 1.5rem !important;\n  }\n\n  .component-section .MuiSvgIcon-root {\n    font-size: 32px !important;\n  }\n}\n\n.button-wrapper {\n  display: flex;\n  justify-content: center;\n  margin-top: 26px;\n}\n\n/* bigger blue button */\n.blue-card-button {\n  background: #257af9;\n  color: white;\n  border: none;\n  padding: 40px 44px;\n  /* increased size */\n  border-radius: 50px;\n  font-size: 20px;\n  /* bigger text */\n  font-weight: 500;\n  cursor: pointer;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  transition: 0.2s;\n}\n\n.blue-card-button:hover {\n  background: #2cb3f6;\n  transform: translateY(-1px);\n}\n\n/* ── Plan Modal ──────────────────────────────────── */\n.plan-modal-section-title {\n  font-size: 0.82rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: #f99022;\n  border-bottom: 2px solid #f990221a;\n  padding-bottom: 4px;\n  padding-Top: 14px;\n  margin-bottom: 12px;\n}\n\n.plan-modal-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px 16px;\n}\n\n.plan-modal-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.plan-modal-field--wide {\n  grid-column: span 2;\n}\n\n.plan-modal-field label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #555;\n}\n\n.plan-modal-field input,\n.plan-modal-select {\n  border: 1px solid #d0d0d0;\n  border-radius: 6px;\n  padding: 7px 10px;\n  font-size: 0.85rem;\n  font-family: 'Poppins', sans-serif;\n  color: #222;\n  outline: none;\n  transition: border 0.2s;\n  width: 100%;\n  background: #fff;\n}\n\n.plan-modal-field input:focus,\n.plan-modal-select:focus {\n  border-color: #f99022;\n}\n\n.plan-modal-time {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.plan-modal-time input {\n  width: 70px;\n  text-align: center;\n}\n\n.plan-modal-time span {\n  font-weight: 700;\n  color: #666;\n  font-size: 1rem;\n}\n/* ─── Operator dropdown thin scrollbar ─── */\n.operator-select-menu ul::-webkit-scrollbar,\n.operator-select-menu::-webkit-scrollbar {\n  width: 4px;\n}\n\n.operator-select-menu ul::-webkit-scrollbar-track,\n.operator-select-menu::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.operator-select-menu ul::-webkit-scrollbar-thumb,\n.operator-select-menu::-webkit-scrollbar-thumb {\n  background: #f99022;\n  border-radius: 4px;\n}\n\n/* ─── Theme Toggle Button ─── */\n.theme-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 1.1rem;\n  transition: background-color 0.2s ease, color 0.2s ease;\n  background-color: #f3f4f6;\n  color: #374151;\n  margin-left: 8px;\n  flex-shrink: 0;\n}\n\n.theme-toggle:hover {\n  background-color: #e5e7eb;\n}\n\n/* ─── CSS Variables (light = default) ─── */\n.operator-screen {\n  --bg-primary:        #ffffff;\n  --bg-surface:        #f9fafb;\n  --bg-card:           #ffffff;\n  --text-primary:      #111827;\n  --text-secondary:    #4b5563;\n  --text-muted:        #9ca3af;\n  --border-color:      #e5e7eb;\n  --footer-hover-bg:   #f3f4f6;\n  --time-label-color:  #374151;\n  --progress-bg:       #f0f0f0;\n}\n\n/* ─── Dark palette — warm slate, easy on the eyes ─── */\n.operator-screen[data-theme=\"dark\"] {\n  --bg-primary:        #1a1d23;\n  --bg-surface:        #22262e;\n  --bg-card:           #2a2f3a;\n  --text-primary:      #f1f5f9;\n  --text-secondary:    #94a3b8;\n  --text-muted:        #64748b;\n  --border-color:      #334155;\n  --footer-hover-bg:   #2d3340;\n  --time-label-color:  #cbd5e1;\n  --progress-bg:       #2d3340;\n}\n\n/* ─── Apply variables to operator-screen elements ─── */\n.operator-screen {\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.operator-screen .header {\n  border-bottom-color: var(--border-color);\n  transition: border-color 0.3s ease, background-color 0.3s ease;\n}\n\n.operator-screen[data-theme=\"dark\"] .header {\n  background-color: var(--bg-surface);\n}\n\n.operator-screen .header-text-element h5 {\n  color: var(--text-muted);\n}\n\n.operator-screen .calendar p,\n.operator-screen .date-label {\n  color: var(--text-primary);\n}\n\n.operator-screen .footer-left,\n.operator-screen .footer-right {\n  border-color: var(--border-color);\n  color: var(--text-primary);\n  background-color: var(--bg-primary);\n  transition: background-color 0.2s ease, border-color 0.3s ease, color 0.3s ease;\n}\n\n.operator-screen .footer-left:hover,\n.operator-screen .footer-right:hover {\n  background-color: var(--footer-hover-bg);\n  border-color: #F99022;\n}\n\n.operator-screen .time-label,\n.operator-screen .login-time-label {\n  color: var(--time-label-color);\n}\n\n.operator-screen .job-stats-section p {\n  color: var(--text-primary);\n}\n\n.operator-screen .actual {\n  color: var(--text-secondary);\n}\n\n.operator-screen .contect-section {\n  color: var(--text-primary);\n}\n\n.operator-screen .job-code {\n  color: var(--text-primary);\n}\n\n.operator-screen .job-name {\n  color: var(--text-secondary);\n}\n\n.operator-screen .time-item span {\n  color: var(--text-primary);\n}\n\n.operator-screen .time-item p {\n  color: var(--time-label-color);\n}\n\n.operator-screen .actual-label {\n  color: var(--text-secondary);\n}\n\n.operator-screen .progress-wrapper,\n.operator-screen .progress-bar {\n  background-color: var(--progress-bg);\n}\n\n/* ─── Dark toggle button ─── */\n.operator-screen[data-theme=\"dark\"] .theme-toggle {\n  background-color: #334155;\n  color: #fbbf24;\n}\n\n.operator-screen[data-theme=\"dark\"] .theme-toggle:hover {\n  background-color: #3d4f66;\n}\n\n/* ═══════════════════════════════════════════════════\n   GLOBAL DARK — MUI portals + SweetAlert2\n   Portals render outside .operator-screen so we scope\n   to body[data-theme=\"dark\"] set by useEffect\n   ═══════════════════════════════════════════════════ */\n\n/* ─── MUI Select / Autocomplete dropdown ─── */\nbody[data-theme=\"dark\"] .MuiPaper-root,\nbody[data-theme=\"dark\"] .MuiPopover-paper,\nbody[data-theme=\"dark\"] .MuiMenu-paper,\nbody[data-theme=\"dark\"] .MuiAutocomplete-paper {\n  background-color: #22262e !important;\n  color: #f1f5f9 !important;\n  border: 1px solid #334155;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5) !important;\n}\n\nbody[data-theme=\"dark\"] .MuiMenuItem-root {\n  color: #f1f5f9 !important;\n}\n\nbody[data-theme=\"dark\"] .MuiMenuItem-root:hover,\nbody[data-theme=\"dark\"] .MuiMenuItem-root.Mui-focusVisible {\n  background-color: #2d3340 !important;\n}\n\nbody[data-theme=\"dark\"] .MuiMenuItem-root.Mui-selected {\n  background-color: rgba(249, 144, 34, 0.15) !important;\n  color: #f99022 !important;\n}\n\nbody[data-theme=\"dark\"] .MuiMenuItem-root.Mui-selected:hover {\n  background-color: rgba(249, 144, 34, 0.25) !important;\n}\n\nbody[data-theme=\"dark\"] .MuiAutocomplete-option {\n  color: #f1f5f9 !important;\n}\n\nbody[data-theme=\"dark\"] .MuiAutocomplete-option:hover,\nbody[data-theme=\"dark\"] .MuiAutocomplete-option[aria-selected=\"true\"] {\n  background-color: #2d3340 !important;\n}\n\nbody[data-theme=\"dark\"] .MuiAutocomplete-noOptions {\n  color: #94a3b8 !important;\n  background-color: #22262e !important;\n}\n\n/* ─── MUI Dialog ─── */\nbody[data-theme=\"dark\"] .MuiDialog-paper {\n  background-color: #22262e !important;\n  color: #f1f5f9 !important;\n  border: 1px solid #334155;\n}\n\nbody[data-theme=\"dark\"] .MuiDialogTitle-root {\n  color: #f1f5f9 !important;\n  border-bottom: 1px solid #334155;\n}\n\nbody[data-theme=\"dark\"] .MuiDialogContent-root {\n  color: #cbd5e1 !important;\n}\n\nbody[data-theme=\"dark\"] .MuiDialogActions-root {\n  border-top: 1px solid #334155;\n}\n\nbody[data-theme=\"dark\"] .MuiDialogContentText-root {\n  color: #94a3b8 !important;\n}\n\n/* ─── MUI TextField / Input inside dialogs ─── */\nbody[data-theme=\"dark\"] .MuiOutlinedInput-root {\n  background-color: #2a2f3a !important;\n  color: #f1f5f9 !important;\n}\n\nbody[data-theme=\"dark\"] .MuiOutlinedInput-notchedOutline {\n  border-color: #334155 !important;\n}\n\nbody[data-theme=\"dark\"] .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #f99022 !important;\n}\n\nbody[data-theme=\"dark\"] .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #f99022 !important;\n}\n\nbody[data-theme=\"dark\"] .MuiInputLabel-root {\n  color: #94a3b8 !important;\n}\n\nbody[data-theme=\"dark\"] .MuiInputLabel-root.Mui-focused {\n  color: #f99022 !important;\n}\n\nbody[data-theme=\"dark\"] .MuiInputBase-input {\n  color: #f1f5f9 !important;\n}\n\n/* Select displayed value text — target every class combination MUI uses */\nbody[data-theme=\"dark\"] .MuiSelect-select,\nbody[data-theme=\"dark\"] .MuiSelect-outlined,\nbody[data-theme=\"dark\"] .MuiSelect-select.MuiInputBase-input,\nbody[data-theme=\"dark\"] .MuiSelect-select.MuiOutlinedInput-input,\nbody[data-theme=\"dark\"] .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input,\nbody[data-theme=\"dark\"] .MuiInputBase-root .MuiSelect-select,\nbody[data-theme=\"dark\"] .MuiOutlinedInput-root .MuiSelect-select,\nbody[data-theme=\"dark\"] .MuiSelect-nativeInput {\n  color: #f1f5f9 !important;\n  -webkit-text-fill-color: #f1f5f9 !important;\n}\n\n/* Dropdown arrow icon */\nbody[data-theme=\"dark\"] .MuiSelect-icon,\nbody[data-theme=\"dark\"] .MuiSvgIcon-root.MuiSelect-icon {\n  color: #94a3b8 !important;\n}\n\n/* FormLabel / InputLabel (used in CustomDaySelect) */\nbody[data-theme=\"dark\"] .MuiFormLabel-root,\nbody[data-theme=\"dark\"] .MuiInputLabel-root,\nbody[data-theme=\"dark\"] .MuiFormLabel-root.MuiInputLabel-root {\n  color: #94a3b8 !important;\n}\n\nbody[data-theme=\"dark\"] .MuiFormLabel-root.Mui-focused,\nbody[data-theme=\"dark\"] .MuiInputLabel-root.Mui-focused {\n  color: #f99022 !important;\n}\n\n/* ─── MUI Checkbox ─── */\nbody[data-theme=\"dark\"] .MuiCheckbox-root {\n  color: #64748b !important;\n}\n\nbody[data-theme=\"dark\"] .MuiCheckbox-root.Mui-checked {\n  color: #f99022 !important;\n}\n\nbody[data-theme=\"dark\"] .MuiListItemText-primary {\n  color: #f1f5f9 !important;\n}\n\nbody[data-theme=\"dark\"] .MuiListItemText-secondary {\n  color: #94a3b8 !important;\n}\n\n/* ─── MUI Button in dialogs ─── */\nbody[data-theme=\"dark\"] .MuiButton-root {\n  color: #f1f5f9 !important;\n}\n\nbody[data-theme=\"dark\"] .MuiButton-contained {\n  background-color: #f99022 !important;\n  color: #fff !important;\n}\n\nbody[data-theme=\"dark\"] .MuiButton-contained:hover {\n  background-color: #e07d10 !important;\n}\n\n/* ─── MUI Divider ─── */\nbody[data-theme=\"dark\"] .MuiDivider-root {\n  border-color: #334155 !important;\n}\n\n/* ─── SweetAlert2 ─── */\nbody[data-theme=\"dark\"] .swal2-popup {\n  background-color: #22262e !important;\n  color: #f1f5f9 !important;\n  border: 1px solid #334155 !important;\n  outline: none !important;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6) !important;\n}\n\nbody[data-theme=\"dark\"] .swal2-title {\n  color: #f1f5f9 !important;\n}\n\nbody[data-theme=\"dark\"] .swal2-content,\nbody[data-theme=\"dark\"] .swal2-html-container {\n  color: #cbd5e1 !important;\n}\n\nbody[data-theme=\"dark\"] .swal2-input,\nbody[data-theme=\"dark\"] .swal2-select,\nbody[data-theme=\"dark\"] .swal2-textarea {\n  background-color: #2a2f3a !important;\n  color: #f1f5f9 !important;\n  border: 1px solid #334155 !important;\n}\n\nbody[data-theme=\"dark\"] .swal2-input:focus,\nbody[data-theme=\"dark\"] .swal2-select:focus,\nbody[data-theme=\"dark\"] .swal2-textarea:focus {\n  border-color: #f99022 !important;\n  box-shadow: 0 0 0 3px rgba(249, 144, 34, 0.2) !important;\n}\n\nbody[data-theme=\"dark\"] .swal2-confirm {\n  background-color: #f99022 !important;\n  color: #fff !important;\n}\n\nbody[data-theme=\"dark\"] .swal2-cancel {\n  background-color: #374151 !important;\n  color: #f1f5f9 !important;\n}\n\nbody[data-theme=\"dark\"] .swal2-deny {\n  background-color: #dc2626 !important;\n  color: #fff !important;\n}\n\nbody[data-theme=\"dark\"] .swal2-validation-message {\n  background-color: #2a2f3a !important;\n  color: #f87171 !important;\n  border-color: #dc2626 !important;\n}\n\nbody[data-theme=\"dark\"] .swal2-close {\n  color: #94a3b8 !important;\n}\n\nbody[data-theme=\"dark\"] .swal2-close:hover {\n  color: #f1f5f9 !important;\n}\n\n/* ─── Blue card notification dropdown ─── */\nbody[data-theme=\"dark\"] .operator-screen .header .calendar-container > div[style] {\n  background-color: #22262e !important;\n  border-color: #334155 !important;\n}\n\n/* ─── MUI Backdrop ─── */\nbody[data-theme=\"dark\"] .MuiBackdrop-root {\n  background-color: rgba(0, 0, 0, 0.7) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
